AOS.init({
	duration: 700,
	easing: 'ease-out',
	once: true,
	offset: 80,
	throttleDelay: 150,
	debounceDelay: 80,
	disable: 'mobile',
})
